import '../main'
import pullRefresh from './src/pullRefresh.vue'

pullRefresh.install = function (Vue) {
    Vue.component(pullRefresh.name, pullRefresh)
}

export default pullRefresh


// WEBPACK FOOTER //
// ./src/components/pullRefresh/index.js